import { checkDiff } from '../../../../utils/formValidation/errorCheckingFunctions';
import {
    validateBarrierNameId, validateDaysAfterPreviousModule,
    validateModuleDescription,
    validateModuleName,
    validateSessionNumber,
    validateSmartTargetAction,
    validateSmartTargetName
} from '../../utils/validationFunctions';

export const validate = (newEntry, type, initialEntry = {}, sessionBased = false) => {
    let newErrors = {};

    newErrors = validateModuleName(newEntry.name, newErrors);
    newErrors = validateModuleDescription(newEntry.description, newErrors);

    if (newEntry.smartTarget) {
        newErrors = validateSmartTargetName(newEntry.smartTarget.name, newErrors);
        newErrors = validateBarrierNameId(newEntry.smartTarget.barrierNameId, newErrors);
        newErrors = validateSmartTargetAction(newEntry.smartTarget.action, newErrors);
    }

    if (sessionBased) {
        newErrors = validateSessionNumber(newEntry.sessionNumber, newErrors);
        if (+newEntry.sessionNumber > 1)
            newErrors = validateDaysAfterPreviousModule(
                newEntry.daysAfterPreviousModule,
                newErrors
            );
    }

    if (type === 'edit' && Object.keys(newErrors).length < 1) {
        newErrors = checkDiff(newEntry, initialEntry);
    }

    return newErrors;
};
